import { CloseButton, Col, Modal, Row, Form } from "react-bootstrap";
import { TextButton } from "Components/Button";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setFirstName, setLastName, setToken, setLastLoginDate, setPsoName, setRole } from "Store/LoginInfoSlice";
import { httpLogin } from "Utils/httpLogin";
import { useRef } from "react";
import { PageInfo } from "Components/PageInformation/PageInformation";
import { PATHS } from "Utils/PagePaths";
import { ROLES } from "Utils/constants";

const MfaTokenPopup = ({
  show,
  handleClose,
  mfaFactors
}) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loginInfo = useSelector(state => state.loginInfo);
  const [tokenRequest, setTokenRequest] = useState({
    mfaToken: ""
  });
  const [showSendCodeMsg, setShowSendCodeMsg] = useState(false);
  const [disableSendCode, setDisableSendCode] = useState(false);
  const [globalErrorList, setGlobalErrorList] = useState([]);
  const [disableMfaTokenField, setDisableMfaTokenField] = useState(true);
  const tokenInputRef = useRef();

  useEffect(() => {
    setGlobalErrorList([]);
  }, [show]);

  const sendCode = async () => {

    /** 1. clear mfatoken field 
     *  2. display "show send code message" 
     ** 3. disalbe "Send Code" for 30 seconds
    */
    setTokenRequest({
      mfaToken: ""
    });
    setGlobalErrorList([]);
    setShowSendCodeMsg(true);
    setDisableSendCode(true);
    setInterval(() => {
      setDisableSendCode(false);
    }, 30000);

    const res = await getToken();

    if (res && res.status !== 200) {
      setGlobalErrorList(res.data.globalErrorMessageList);
    } else {
      tokenInputRef.current.focus();
    }
  }

  const getToken = async () => {

    const res = httpLogin.post('/auth/mfa/sendToken', {}, {
      headers: {
        // token start with "Bearer " to map with java backend JwtUtil.java
        "Authorization": "Bearer " + loginInfo.mfaToken
      }
    }).catch(function (error) {
      return error.response;
    });

    setDisableMfaTokenField(false);

    return res;
  }

  //sms token verification
  const verifyToken = async () => {
    const res = await submitToken();
    
    /**
     * response example:
     * {
     *  status: 3,
     *  fieldErros: {},
     *  globalErrorMessageList: [],
     *  data: {
     *     firstName: "test",
     *     lastName: "test",
     *     psoName: "test",  
     *     psoId: null,
     *     userRole: {
     *      roleId: 10004,
     *      roleName: "PSOPPC Admin",
     *      description: "PSOPPC Admin",
     *      isEnabled: 1
     *     },
     *  lastLoginDateString: "Jul 01, 2026"
     *  }
     * 
     * }
     */
    if (res && res.status === 200) {
      if (res.data) {
        dispatch(setToken(res.headers["authorization"]));
        dispatch(setFirstName(res.data.data.firstName));
        dispatch(setLastName(res.data.data.lastName));
        dispatch(setPsoName(res.data.data.psoName));
        dispatch(setLastLoginDate(res.data.data.lastLoginDateString));
        // !!! pointed to the role info
        dispatch(setRole(res.data.data.userRole?.roleName));

        var userRole = res.data.data.userRole?.roleName;
        if (userRole == ROLES.L1.id || userRole == ROLES.AUSER.id) {
          navigate("/helpcenter");
        }
        else {
          navigate("/dashboard");
        }
      }
    } else {
      setGlobalErrorList(res.data.globalErrorMessageList);
    }
  }

  const submitToken = async () => {

    const res = httpLogin.post('/auth/mfa/verifyToken', tokenRequest, {
      headers: {
        // token start with "Bearer " to map with java backend JwtUtil.java
        "Authorization": "Bearer " + loginInfo.mfaToken
      }
    }).catch(function (error) {
      return error.response;
    });

    return res;
  }

  // only allow numbers
  const handleCodeChange = (e) => {
    let value = e.target.value;
    const regex = /^[0-9\b]+$/;

    if (value === '' || regex.test(value)) {
      setTokenRequest({
        ...tokenRequest,
        mfaToken: value
      });
    }
  }

  const cancelMfa = () => {
    setTokenRequest({
      mfaToken: ""
    });
    setShowSendCodeMsg(false);
    setDisableSendCode(false);
    setDisableMfaTokenField(true);
    dispatch(setToken(""));
    handleClose();
    navigate(PATHS.public['Sign In']);
  }

  return (
    <Modal
      id="sms-mfa-token-popup"
      className="modal"
      size="lg"
      backdrop="static"
      show={show}
      centered
    >
      <Modal.Header className="ps-5 pe-5 pt-5">
        <Modal.Title>
          <h2 className="pb-3"><CloseButton className="closeup-popup-button" onClick={cancelMfa}></CloseButton></h2>
          <h2 className="text-start title">Two-Factor Authentication</h2>
          <h6 className="text-start subtitle">Please click the <span className="highlight">Send Code</span> button to receive your challenge code on your registered mobile device. Please enter the code in the text box and click the <span className="highlight">Verify</span> button.</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-4 pb-5 ps-5 pe-5">
        {showSendCodeMsg ?
          <PageInfo type="info" message={"A code has been sent to your registered cell phone. Please enter that code in the field below. You may send a new code after 30 seconds if needed."}></PageInfo>
          : null}
        {globalErrorList.map((item, index) =>
          <>
            <Row className="pt-4"></Row>
            <PageInfo key={"errors_" + index} type="error" message={item}></PageInfo>
          </>
        )}
        <Form className="pt-4">
          <Row className="mb-3">
            {/* <Col sm="7" className="mfa-setting-label pt-1">1. Click to send code to your registered mobile device</Col> */}
            <Col sm="7" className="mfa-setting-label pt-1">
              <div class="mfa-setting-step">
                <span>1.</span>
                <span>Click to send code to <span className="sms-last4-label">***-***-{mfaFactors.smsLast4}</span>.</span>
              </div>
            </Col>
            <Col>
              <TextButton
                disabled={disableSendCode}
                variant="normal"
                onClick={sendCode}
                content={"Send Code"}
              >
              </TextButton>
            </Col>
          </Row >
          <br />
          <Form.Group as={Row} className="mb-3" controlId="mfaToken">
            <Form.Label column sm="7" className="mfa-setting-label">
              2. Enter the six digit code.
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                style={{ width: "7rem" }}
                ref={tokenInputRef}
                disabled={disableMfaTokenField}
                type="text"
                maxlength={6}
                value={tokenRequest.mfaToken}
                onChange={handleCodeChange}
              />
            </Col>
          </Form.Group>
          <br />
          <Row className="mb-3 pt-1">
            <Col sm="7" className="mfa-setting-label pt-1">3. Click Verify to confirm.</Col>
            <Col>
              <TextButton
                className="w-10"
                variant="normal"
                disabled={tokenRequest.mfaToken.length !== 6}
                onClick={verifyToken}
                content={"Verify"}
              >
              </TextButton>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <TextButton
                className="w-10"
                variant="outline"
                onClick={cancelMfa}
                content={"Cancel"}
              >
              </TextButton>
            </Col>
          </Row>
        </Form >
      </Modal.Body>
    </Modal>
  )
}

export default MfaTokenPopup;